import type { $Fetch } from 'ofetch';
import type { MantenedoraGateway, ListMantenedorasParams } from '@/application/port/out/MantenedoraGateway';
import type { Mantenedora, UpsertMantenedoraCommand } from '@/domain/model/Mantenedora';
import type { Page } from '@/domain/model/Page';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const ROOT = '/api/v1/admin/mantenedoras';

/** HTTP gateway do CRUD de Mantenedora (SuperAdmin). Authority BE: `org:mantenedora:read|create|update`. */
export class HttpMantenedoraGateway implements MantenedoraGateway {
  constructor(private readonly client: $Fetch) {}

  async list(params: ListMantenedorasParams): Promise<Page<Mantenedora>> {
    const query: Record<string, string | number> = { page: params.page, size: params.size };
    if (params.q) query.q = params.q;
    const res = await this.client<ApiResponse<Page<Mantenedora>>>(ROOT, { method: 'GET', params: query });
    assertApiSuccess(res);
    return res.data;
  }

  async get(id: string): Promise<Mantenedora> {
    const res = await this.client<ApiResponse<Mantenedora>>(`${ROOT}/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: UpsertMantenedoraCommand): Promise<Mantenedora> {
    const res = await this.client<ApiResponse<Mantenedora>>(ROOT, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: UpsertMantenedoraCommand): Promise<Mantenedora> {
    const res = await this.client<ApiResponse<Mantenedora>>(`${ROOT}/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async deactivate(id: string): Promise<Mantenedora> {
    // BE retorna 200 + a entidade desativada (não 204) — usa o envelope.
    const res = await this.client<ApiResponse<Mantenedora>>(`${ROOT}/${encodeURIComponent(id)}`, { method: 'DELETE' });
    assertApiSuccess(res);
    return res.data;
  }
}
